// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"1198":"413db34349b400d5","3699":"fbc78f0c7816520f","4235":"bec653ee80459e3f","6455":"8044c9975704f233","7045":"0dc669a4e236a390"}[chunkId] + ".js";
};